(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.galleryReady) return;
      section.dataset.galleryReady = 'true';
      const hero = section.querySelector('.dc-product-media-image');
      if (!hero) return;
      const buttons = section.querySelectorAll('[data-gallery-image]');
      buttons.forEach(button => button.addEventListener('click', () => {
        hero.removeAttribute('srcset');
        hero.src = button.dataset.galleryImage;
        hero.alt = button.dataset.galleryAlt || '';
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
